import { render } from "./CSessionManager.vue?vue&type=template&id=02353daa"
import script from "./CSessionManager.vue?vue&type=script&lang=js"
export * from "./CSessionManager.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__